import { render, staticRenderFns } from "./OnlineList.vue?vue&type=template&id=23f7247c&scoped=true"
import script from "./OnlineList.vue?vue&type=script&lang=js"
export * from "./OnlineList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f7247c",
  null
  
)

export default component.exports